// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 3584) return "static/chunks/3584.b1607b7699cf2489.js";
	if (chunkId === 422) return "static/chunks/422.78b5a0c97320b1ee.js";
	if (chunkId === 8525) return "static/chunks/8525.421ded4b6f53f1c9.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"53":"923a4f74b1324b63","561":"c09438adef52064e","1305":"c5a3ce2bb2908c51","2227":"e29fc46bdf87cc53","4584":"0ba2e435de3ac154","4781":"f024ac8cf95f62c1","5397":"3899714e9fab5a51","5487":"6dc056a1caf21490","6413":"67682a7538888de3","6786":"301892ce1c05846c","7002":"972e46170e7f9e57","8811":"5af987b718e7437e","9720":"98210d8fc2ff5f14"}[chunkId] + ".js";
};